module.exports = __webpack_public_path__ + "static/media/download.e99ccfb2.svg";